Vue.component('contact-form', require('./ContactForm.vue').default);
